import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

let connectedUserId = null

// Keeps web and native notification badges on the persisted server count. The
// channel transmits immediately on connect, then broadcasts after every create or
// read, so Turbo cache restoration and delayed foreground pushes cannot drift it.
export default class extends Controller {
  static targets = ["count"]
  static values = { userId: Number }

  connect() {
    // Turbo keeps the shared Action Cable consumer alive between page visits.
    // Impersonation changes the effective user cookie, so reconnect the socket
    // whenever the page's effective user differs from the previous one.
    if (connectedUserId !== null && connectedUserId !== this.userIdValue) {
      consumer.disconnect()
      consumer.connect()
    }
    connectedUserId = this.userIdValue

    this._subscription = consumer.subscriptions.create(
      { channel: "NotificationChannel" },
      {
        received: (data) => {
          this.update(data?.unread_count)
          document.dispatchEvent(new CustomEvent("notifications:changed", { detail: data }))
        }
      }
    )
  }

  disconnect() {
    this._subscription?.unsubscribe()
  }

  update(value) {
    const count = Math.max(0, parseInt(value, 10) || 0)
    const meta = document.querySelector('meta[name="unread-notifications"]')
    if (meta) meta.content = String(count)

    this.countTargets.forEach((badge) => {
      badge.textContent = count > 99 ? "99+" : String(count)
      badge.style.display = count > 0 ? "block" : "none"
    })

    if (window.webkit?.messageHandlers?.nativeBadge) {
      window.webkit.messageHandlers.nativeBadge.postMessage(count)
    }
  }
}
